const bridge = () =>
  typeof window !== "undefined" ? window.desktopOfflineCategories : null;

const requireBridge = () => {
  const api = bridge();
  if (!api) throw new Error("Offline category storage is unavailable.");
  return api;
};

export const hasOfflineCategoryStore = () => Boolean(bridge());

export const listOfflineCategories = (restaurantId) =>
  requireBridge().list({ restaurantId });

export const createOfflineCategory = (restaurantId, name) =>
  requireBridge().create({ restaurantId, name });

export const updateOfflineCategory = (restaurantId, categoryId, name, isActive) =>
  requireBridge().update({ restaurantId, categoryId, name, isActive });

export const deleteOfflineCategory = (restaurantId, categoryId) =>
  requireBridge().remove({ restaurantId, categoryId });
